import { render, staticRenderFns } from "./BusReservation.vue?vue&type=template&id=1420fc91&scoped=true&"
import script from "./BusReservation.vue?vue&type=script&lang=js&"
export * from "./BusReservation.vue?vue&type=script&lang=js&"
import style0 from "./BusReservation.vue?vue&type=style&index=0&id=1420fc91&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1420fc91",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VForm,VSelect,VTextField,VTextarea})
